import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { Usuario } from '../../login/usuario';
import { DashboardService } from '../../../../services/dashboard.service';
import { DashboardDto, MarcoDto, RecordeDto } from '../../../../models/dashboard';

interface BarraSemana {
  label: string;
  execucoesPct: number;
  cargaPct: number;
  cardioPct: number;
}

@Component({
  selector: 'app-treino-dashboard',
  standalone: false,
  templateUrl: './treino-dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './treino-dashboard.component.css',
})
export class TreinoDashboardComponent implements OnInit {

  user: Usuario | null = null;

  carregando = true;
  erro = false;
  dashboard: DashboardDto | null = null;

  barras: BarraSemana[] = [];
  recordes: RecordeDto[] = [];
  marcos: MarcoDto[] = [];

  constructor(
    private authService: AuthService,
    private dashboardService: DashboardService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.user = this.authService.getUser();

    if (!this.user) {
      this.router.navigate(['/login'], {
        queryParams: { retUrl: '/treino-dashboard' }
      });
      return;
    }

    this.carregar();
  }

  carregar(): void {
    this.carregando = true;
    this.erro = false;

    this.dashboardService.getDashboard().subscribe({
      next: (res) => {
        this.dashboard = res;
        this.recordes = res.recordesRecentes ?? [];
        this.marcos = res.marcos ?? [];
        this.barras = this.buildBarras(res);
        this.carregando = false;
      },
      error: () => {
        this.carregando = false;
        this.erro = true;
      }
    });
  }

  private buildBarras(dto: DashboardDto): BarraSemana[] {
    const semanas = dto.volumeSemanal ?? [];

    const maxExecucoes = Math.max(1, ...semanas.map(s => s.execucoes));
    const maxCarga = Math.max(1, ...semanas.map(s => s.cargaTotal));
    const maxCardio = Math.max(1, ...semanas.map(s => s.distanciaCardioKm));

    return semanas.map(s => ({
      label: this.formatarDiaMes(s.inicioSemana),
      execucoesPct: this.percentualComPiso(s.execucoes, maxExecucoes),
      cargaPct: this.percentualComPiso(s.cargaTotal, maxCarga),
      cardioPct: this.percentualComPiso(s.distanciaCardioKm, maxCardio),
    }));
  }

  private percentualComPiso(valor: number, max: number): number {
    if (!valor) return 4;
    return Math.max(6, Math.round((valor / max) * 100));
  }

  formatarDiaMes(iso: string): string {
    const d = new Date(iso);
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
  }

  formatarData(iso: string): string {
    const d = new Date(iso);
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  formatarPeso(valor: number): string {
    return `${valor.toLocaleString('pt-BR', { maximumFractionDigits: 1 })} kg`;
  }

  formatarVariacao(valor: number | null): string {
    if (valor === null || valor === undefined) {
      return 'sem dados do período anterior';
    }
    const sinal = valor > 0 ? '+' : '';
    return `${sinal}${valor}% vs período anterior`;
  }

  get temDados(): boolean {
    return !!this.dashboard && (this.dashboard.temExecucoes || this.dashboard.temTreinoConfigurado);
  }
}
